export const AUCTION_TIME_GROUP = {
  TWO_HUNDRED: { value: 1, text: "0 - 200" },
  FOUR_HUNDRED: { value: 2, text: "201 - 400" },
  SIX_HUNDRED: { value: 3, text: "401 - 600" },
  EIGHT_HUNDRED: { value: 4, text: "601 - 800" },
  ONE_THOUSAND: { value: 5, text: "801 - 1000" },
  ONE_THOUSAND_TWO_HUNDRED: { value: 6, text: "1001 - 1200" },
  ONE_THOUSAND_FOUR_HUNDRED: { value: 7, text: "1201 - 1400" },
  ONE_THOUSAND_SIX_HUNDRED: { value: 8, text: "1401 - 1600" },
  ONE_THOUSAND_EIGHT_HUNDRED: { value: 9, text: "1601 - 1800" },
  TWO_THOUSAND: { value: 10, text: "1801 - 2000" },
  TWO_THOUSAND_TWO_HUNDRED: { value: 11, text: "2001 - 2200" },
  TWO_THOUSAND_FOUR_HUNDRED: { value: 12, text: "2201 - 2400" },
  TWO_THOUSAND_SIX_HUNDRED: { value: 13, text: "2401 - 2600" },
  TWO_THOUSAND_EIGHT_HUNDRED: { value: 14, text: "2601 - 2800" },
  THREE_THOUSAND: { value: 15, text: "2801 - 3000" },
} as const;

export const SCALE_TYPE = {
  LINEAR: { value: "linear", text: "線形軸" },
  LOGARITHMIC: { value: "logarithmic", text: "対数軸" },
} as const;

export const CHART_COLOR = {
  RED: {
    value: 0,
    colorName: "red--text text--darken-1",
    colorCode: "#E53935",
    highlightColorCode: "#EF9A9A",
  },
  AMBER: {
    value: 1,
    colorName: "amber--text",
    colorCode: "#FFC107",
    highlightColorCode: "#FFE082",
  },
  YELLOW: {
    value: 2,
    colorName: "yellow--text",
    colorCode: "#FFEB3B",
    highlightColorCode: "#FFF59D",
  },
  LIME: {
    value: 3,
    colorName: "lime--text",
    colorCode: "#CDDC39",
    highlightColorCode: "#E6EE9C",
  },
  LIGHT_GREEN: {
    value: 4,
    colorName: "light-green--text",
    colorCode: "#8BC34A",
    highlightColorCode: "#C5E1A5",
  },
  CYAN: {
    value: 5,
    colorName: "cyan--text",
    colorCode: "#00BCD4",
    highlightColorCode: "#80DEEA",
  },
  BLUE: {
    value: 6,
    colorName: "blue--text",
    colorCode: "#2196F3",
    highlightColorCode: "#90CAF9",
  },
  INDIGO: {
    value: 7,
    colorName: "indigo--text",
    colorCode: "#3F51B5",
    highlightColorCode: "#9FA8DA",
  },
  PURPLE: {
    value: 8,
    colorName: "purple--text",
    colorCode: "#9C27B0",
    highlightColorCode: "#CE93D8",
  },
  PINK: {
    value: 9,
    colorName: "pink--text text--lighten-1",
    colorCode: "#EC407A",
    highlightColorCode: "#F48FB1",
  },
  BLUE_GRAY: {
    value: 10,
    colorName: "blue-grey--text text--lighten-4",
    colorCode: "#EEEEEE",
    highlightColorCode: "#F5F5F5",
  },
} as const;
